import React, { useImperativeHandle } from 'react';
import Narrative, {
  FeedbackMakeEditsNarrativeHandler,
} from '../../../ReportBuilder/Components/Narrative';
import { FeedbackQuestionHandler, FeedbackSectionInfo } from '../utils';

const noOp = () => null;

const NarrativeSection = React.forwardRef<
  FeedbackQuestionHandler,
  FeedbackSectionInfo
>(
  (
    { reportId, questionId, answer, questionText, isThirdParty, programName },
    forwardRef,
  ) => {
    const ref = React.useRef<FeedbackMakeEditsNarrativeHandler>(null);

    useImperativeHandle(forwardRef, () => ({
      reportId,
      questionId,
      answer: () => {
        const result = ref.current?.handleSubmit();
        return result ? JSON.stringify({ text: result }) : '';
      },
      errorText: () =>
        ref.current?.isValid() ? undefined : 'Please completed all fields',
    }));

    return (
      <Narrative
        questionRef={ref}
        handleBack={noOp}
        handleNext={noOp}
        handleValueChange={noOp}
        onNextSection={noOp}
        onPreviousSection={noOp}
        isThirdParty={isThirdParty}
        programName={programName}
        reportId={reportId}
        hideBottomBar={true}
        guidanceText={{}}
        value={answer}
        question={{
          autoSave: false,
          dbId: questionId,
          enumPrograms: [],
          enumResponses: [],
          feExtraRequirement: null,
          helpContent: null,
          id: questionId,
          nextQuestionId: null,
          questionType: 'RADIO',
          section: 'narrative',
          sectionStart: false,
          tab: null,
          text: questionText,
          text_html: questionText,
          validations: [],
        }}
      />
    );
  },
);

export default NarrativeSection;
